import React from "react";
import ExecutiveHiringbanner from "../../AVHRBanner/ExecutiveHiringNB.png";
import "../OurServicesCss/Services.css";
import { Button } from "primereact/button";
import { FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ExecutiveHig from "../../Images/ExecutiveHiringOneimg.png";
import { Card } from "primereact/card";

function ExecutiveHiring() {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  const points = [
  "🌐 Access to a Curated Network of Industry Leaders",
  "🕵️ Confidential Search for Critical Leadership Roles",
  "📋 Comprehensive Evaluation",
  "🎯 Strategic Alignment with Organizational need",
  "🤝 Culture-Fit Assessment for Long-Term Impact",
  "🧠 In-Depth Leadership Profiling and Benchmarking",
  "⚡ Faster, Quality-Driven Hiring Process",
];


  return (
    <>
      <div style={{ paddingTop: "100px" }}>
        <div className="relative w-full h-[400px] sm:h-[500px] md:h-[600px] lg:h-[700px] xl:h-[800px] banner">
          <img
            src={ExecutiveHiringbanner}
            className="absolute inset-0 w-full h-full object-cover"
            alt=""
          />

          {/* Centered Content */}
          <div className="relative z-10 flex items-center justify-center h-full px-4 text-adjest avhrProject-bannerTextColour-B">
            <div className="text-bannar max-w-3xl text-left">
              <p className="edu-support-text uppercase">Our Services</p>

              <h1 className="career-library-heading">Executive Hiring</h1>

              {/* <p className="mt-4 leading-relaxed">
                
              </p> */}
            </div>
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <div
            className="rounded-lg text-center p-2 sm:p-2 md:p-6 lg:p-2 shadow-md HeadingTagLine"
            style={{
              boxShadow: "0 6px 12px rgba(0, 0, 0, 0.25)",
            }}>
            <h1 className="avhrProject-h1">
              Hire Leaders Who Drive Growth and Culture
            </h1>
            <p className="avhrProject-p ml-4 mr-4" style={{fontSize: "20px"}}>
              At AV-CS, we offer a strategic approach to identify visionary
              leaders who align with your business goals and values. Through a
              rigorous evaluation process and leveraged industry-specific
              insights, we ensure you secure top-tier talent with the leadership
              acumen and capable to drive transformation
            </p>
          </div>
        </div>

        <div
          className="grid align-items-center px-4 md:px-6 py-4 sm:px-6 md:px-10 lg:px-16"
          style={{ backgroundColor: "#f6f6f5" }}>
          {/* Image */}
          <div className="col-12 md:col-6 lg:col-6 text-center md:text-left mb-2 md:mb-0">
            <img
              src={ExecutiveHig}
              alt=""
              className="w-full border-round-lg shadow-4"
            />
          </div>

          {/* Content */}
          <div className="col-12 md:col-6 lg:col-6">
            <h2 className="mb-2 avhrProject-h2 pl-4">What You Gain:</h2>
            <ul className="list-none pl-4">
              {points.map((point, idx) => (
                <li key={idx} className="flex items-start mb-4">
                  {/* <FaCheckCircle className="circelcolour mt-1 mr-2" /> */}
                  <span className="avhrProject-p">{point}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <Card
            className="CARDCOLOUR m-3"
            style={{
              background: "linear-gradient(-120deg, #FFE799, #FF8A80, #FFE799)",
            }}>
            <p className="mb-2 text-center avhrProject-p">Get Started</p>
            <h2 className="mt-2 text-center avhrProject-h2 ">
              Partner with us to identify and onboard executives who don’t just
              lead — they inspire, innovate, communicate and deliver results
            </h2>

            <div className="flex justify-content-center">
              <Button
                label="Contact Us"
                rounded
                onClick={() => handleNavigate("/contactus")}
                className="buttonAvhrProject"
              />
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}

export default ExecutiveHiring;
